let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hnLQ7")).then(() => parcelRequire('eSXVn'));